"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoadingSpinner = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = _interopRequireDefault(require("./config"));
var _styledLoadingSpinner = require("./styled-loading-spinner");
var _excluded = ["dataTestId", "size", "variant", "animationTime", "className"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var colours = _config["default"].colours;
var propTypes = {
  animationTime: _propTypes["default"].number,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['responsive', 'xsmall', 'small', 'medium', 'large']),
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary'])
};
var defaultProps = {
  animationTime: 0.5,
  className: undefined,
  dataTestId: 'fuse-loading-spinner-data-test-id',
  size: 'responsive',
  variant: 'primary'
};
var LoadingSpinner = exports.LoadingSpinner = forwardRef(function (_ref, ref) {
  var dataTestId = _ref.dataTestId,
    size = _ref.size,
    variant = _ref.variant,
    animationTime = _ref.animationTime,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledLoadingSpinner.StyledLoadingSpinnerWrapper, _extends({
    className: className,
    "data-testid": dataTestId,
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledLoadingSpinner.StyledLoadingSpinner, {
    colour: colours["".concat(variant)],
    "aria-live": "polite",
    role: "status",
    size: size,
    animationTime: animationTime
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 50 50",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5"
  })), /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, {
    className: "fuse-loading-spinner__screen-reader-only"
  }, "Loading")));
});
LoadingSpinner.propTypes = propTypes;
LoadingSpinner.defaultProps = defaultProps;
var _default = exports["default"] = LoadingSpinner;